const APP_DISPLAY_NAME = 'Spirara | Booking for Spa and Beauty Businesses';
const APP_SHORT_NAME = 'Spirara';
const A2HS_STORAGE_KEY = 'spirara.a2hs.v1';
export const WELCOME_TOUR_DONE_EVENT = 'spirara:welcome-tour-done';

export const getAppDisplayName = () => APP_DISPLAY_NAME;
export const getAppShortName = () => APP_SHORT_NAME;

export const isA2hsDismissed = () => {
  try {
    return localStorage.getItem(A2HS_STORAGE_KEY) === 'dismissed';
  } catch {
    return false;
  }
};

export const markA2hsDismissed = () => {
  try {
    localStorage.setItem(A2HS_STORAGE_KEY, 'dismissed');
  } catch {
    // ignore
  }
};

export const isStandaloneDisplay = () => {
  if (typeof window === 'undefined') return false;
  if (window.matchMedia?.('(display-mode: standalone)').matches) return true;
  if (window.matchMedia?.('(display-mode: minimal-ui)').matches) return true;
  // iOS Safari installed to home screen
  if (window.navigator.standalone === true) return true;
  return false;
};

export const detectInstallPlatform = () => {
  if (typeof navigator === 'undefined') {
    return { platform: 'other', isMobile: false, isIOS: false, isAndroid: false };
  }

  const ua = navigator.userAgent || '';
  const isIOS =
    /iPad|iPhone|iPod/i.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /Android/i.test(ua);
  const isMobile = isIOS || isAndroid || /Mobi|Mobile|webOS/i.test(ua);

  let platform = 'other';
  if (isIOS) platform = 'ios';
  else if (isAndroid) platform = 'android';

  return { platform, isMobile, isIOS, isAndroid };
};

export const getSiteHost = () => {
  if (typeof window === 'undefined') return 'spirara.com';
  return window.location.host || 'spirara.com';
};
